export default "__VITE_ASSET__C_DozlA4__"